import cart from "./cart.json";
import checkout from "./checkout.json";
import special from "./special.json";
import wishlist from "./wishlist.json";
import returnState from "./return.json";
import manufacturerList from "./manufacturerList.json";
import checkoutSuccess from "./checkoutSuccess.json";
export default {
  cart,
  checkout,
  special,
  wishlist,
  returnState,
  manufacturerList,
  checkoutSuccess,
};
